module.exports = __webpack_public_path__ + "img/bg-type06.994632f4.png";